// Indicator ids
export const STAGE_INDICATOR = 1;
export const KIDNEY_PROGRESSION_INDICATOR = 2;
export const BLOOD_PRESURE_INDICATOR = 3;
export const BLOOD_GLUCOSE_INDICATOR = 4;
export const NUTRITIONAL_INDICATOR = 5;
export const LÍPIDOS_INDICATOR = 6;
export const PTH_INDICATOR = 7;
export const ALBUMIN_INDICATOR = 8;
export const HEMOGLOBINA_INDICATOR = 9;
export const PHOSPHORUS_INDICATOR = 10;
export const POTASIO_INDICATOR = 11;
export const MY_DATES_INDICATOR = 12;
export const ADHERENCE_INDICATOR = 12;
export const MY_RECOMMENDATIONS_INDICATOR = 13;
export const CREATININE_INDICATOR = 52;

// Parameters ids
export const COLESTEROL_PARAM = 9;
export const TRIGLICERIDOS_PARAM = 10;

// Indicator levels
export const HIGH = 'high';
export const NORMAL_LOW = 'normalLow';

// CONDITIONS (diabetes => parametro:25)
export const PATIENT_CONDITIONS = 23;
